'use client'

import { CartIdContext, useRequiredCartContext } from '@/providers/CurrentCartProvider'

export function useCartId() {
  return useRequiredCartContext(CartIdContext, 'useCartId')
}
